import React from 'react';
import acaLogo from '../../assets/acaStackLight.png';

const navigation = {
  main: [
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ]
};

export default function Footer() {
  return (
    <footer className=" border-t border-gray-200" style={{ backgroundColor: '#0D1B2F' }}>
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20 lg:px-8">
        <div className="text-left">
          <nav aria-label="Footer" className="mb-6 flex flex-wrap gap-x-8 gap-y-3 text-sm text-white">
            {navigation.main.map((item) => (
              <a key={item.name} href={item.href} className="hover:text-gray-200">
                {item.name}
              </a>
            ))}
          </nav>

          <p className="text-sm text-white max-w-xl mb-6">
            Advanced Controls & Automation delivers CNC machining, HVAF flame spray coatings, and automated cell design from our facility in Waterford, NY. Proudly serving Upstate New York and the Capital District with precision, speed, and American-made reliability.
          </p>

          <p className="text-sm text-white mb-6">&copy; {new Date().getFullYear()} Advanced Controls & Automation. All rights reserved.</p>

          <img src={acaLogo} alt="Advanced Controls & Automation Logo" className="h-16" />
        </div>
      </div>
    </footer>
  );
}